import React, { createContext, useState } from "react";

const GlobalSearchContext = createContext();

export const GlobalSearchProvider = ({ children }) => {
  const [search, setSearch] = useState({
    isModalOpen: false,
    isLoading: false,
    showIntroMsg: true,
    showErrorMsg: false,
    searchParam: "",
    results: [],
  });

  return (
    <GlobalSearchContext.Provider value={{ search, setSearch }}>
      {children}
    </GlobalSearchContext.Provider>
  );
};

export default GlobalSearchContext;
